<mat-dialog-content class="scrollbar-thumb-rounded scrollbar-track-rounded scrollbar-thin scrollbar-track-transparent scrollbar-thumb-card">
    <div class="example-container">
        <mat-form-field class="example-form-field">
            <mat-label>{{'COMMON.FIRST_NAME' | translate}}</mat-label>
            <input class="border-transparent focus:border-transparent focus:ring-0" [(ngModel)]="filter.firstName"
                [ngModelOptions]="{standalone: true}" matInput type="text" (keydown.enter)="onSearch()"
                placeholder="{{'COMMON.FIRST_NAME' | translate}}">
        </mat-form-field>

        <mat-form-field class="ms-3">
            <mat-label>{{'COMMON.LAST_NAME' | translate}}</mat-label>
            <input class="border-transparent focus:border-transparent focus:ring-0" [(ngModel)]="filter.firstName"
                [ngModelOptions]="{standalone: true}" matInput type="text" (keydown.enter)="onSearch()"
                placeholder="{{'COMMON.LAST_NAME' | translate}}">
        </mat-form-field>

        <button class="ms-3" (click)="onSearch()" color="primary" mat-flat-button>
            {{'COMMON.SEARCH' | translate}}
        </button>
    </div>

    <div class="mt-5">
        <table mat-table class="ws-table" [dataSource]="employees">

            <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef>
                    <div class="flex items-center">
                        <mat-checkbox color="primary" (change)="$event ? toggleAllRows() : null"
                            [checked]="selection.hasValue() && isAllSelected()"
                            [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
                        </mat-checkbox>
                    </div>
                </th>
                <td mat-cell *matCellDef="let row">
                    <mat-checkbox color="primary" (click)="$event.stopPropagation()"
                        (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)"
                        [aria-label]="checkboxLabel(row)">
                    </mat-checkbox>
                </td>
            </ng-container>

            <ng-container matColumnDef="firstName">
                <th mat-header-cell *matHeaderCellDef> {{'COMMON.FIRST_NAME' | translate}} </th>
                <td mat-cell *matCellDef="let element"> {{element.firstName}} </td>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="lastName">
                <th mat-header-cell *matHeaderCellDef> {{'COMMON.LAST_NAME' | translate}}
                </th>
                <td mat-cell *matCellDef="let element"> {{element.lastName}} </td>
            </ng-container>

            <ng-container matColumnDef="departmentName">
                <th mat-header-cell *matHeaderCellDef> {{'DEPARTMENTS.DEPARTMENTS' | translate}} </th>
                <td mat-cell *matCellDef="let element"> {{element.departmentName}} </td>
            </ng-container>

            <ng-container matColumnDef="username">
                <th mat-header-cell *matHeaderCellDef> {{'COMMON.USER_NAME' | translate}} </th>
                <td mat-cell *matCellDef="let element"> {{element.username}} </td>
            </ng-container>


            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <qms-paginator [length]="totalEmployee" [pageSize]="filter.pageSize" [pageSizeOptions]="pageSizeOptions"
            (page)='pageEvent($event)' [size]='"medium"'>
        </qms-paginator>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-stroked-button color="primary" (click)="onCancel()">{{'COMMON.CANCEL' | translate}}</button>
    <button mat-flat-button color="primary" (click)="onSubmit()">{{'COMMON.SAVE'
        | translate}}</button>
</mat-dialog-actions>